export default {"src":"https://s91588.cdn.ngenix.net/affiliates-frontend/_next/static/media/mortgage-insurance.4a8d798e.svg","height":360,"width":462};